import './Home.css'

const About = () => {
  return (
    <div className="home">
      <div className="hero-background"></div>

      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="animate-slideUp stagger-1">
              About <span className="text-gradient">NAH44</span>
            </h1>
            <p className="hero-subtitle animate-slideUp stagger-2">
              A comprehensive digital platform revolutionizing vehicle contact, restaurant management, and financial services.
              We bring together cutting-edge technology to simplify everyday interactions and business operations.
            </p>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2 className="animate-slideUp">What We Stand For</h2>
            <p className="animate-slideUp stagger-1">
              Core principles guiding our platform and services.
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card glass-card">

              <h3>Privacy First</h3>
              <p>We prioritize your privacy while enabling essential communication between vehicle owners and others. Your personal information remains protected.</p>
            </div>
            <div className="feature-card glass-card">

              <h3>Instant Connectivity</h3>
              <p>Connect with vehicle owners instantly through our unique QR code system without compromising personal information. Real-time notifications via SMS and WhatsApp.</p>
            </div>
            <div className="feature-card glass-card">

              <h3>Secure Platform</h3>
              <p>Your data is protected with industry-standard security measures, JWT authentication, and encryption. Built with security as a core principle.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2 className="animate-slideUp">Our Services</h2>
            <p className="animate-slideUp stagger-1">
              Three powerful platforms integrated into one comprehensive solution
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card glass-card">

              <h3>NAH44 Tags</h3>
              <p>
                <strong>Vehicle Contact System</strong><br />
                Generate unlimited QR codes for your vehicles. Enable secure, privacy-first communication when your vehicle is involved in parking issues or accidents.
                Works offline with NFC technology, ensuring you're always reachable. Get instant alerts via SMS and WhatsApp when someone scans your tag.
              </p>
            </div>

            <div className="feature-card glass-card">

              <h3>Franchise Management & QR Menu Ordering</h3>
              <p>
                <strong>Restaurant Digital Transformation</strong><br />
                Complete restaurant management platform with QR-based digital menus, order processing, and billing.
                Manage multiple locations, track orders in real-time, and streamline operations with Kitchen Display System (KDS) integration.
                Customers scan QR codes to view menus, place orders, and pay digitally. Includes table management and detailed analytics.
              </p>
            </div>

            <div className="feature-card glass-card">

              <h3>Recharge Platform</h3>
              <p>
                <strong>All-in-One Payment Solution</strong><br />
                Mobile, DTH, and utility bill payments with secure payment gateways. Fast and reliable recharge services
                with transaction history tracking. Support for multiple operators and seamless payment processing.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2 className="animate-slideUp">Why Choose NAH44?</h2>
            <p className="animate-slideUp stagger-1">
              Premium features designed for your peace of mind and business success
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card glass-card">

              <h3>Works Offline</h3>
              <p>Our NFC tags work even without internet, ensuring you're always reachable. Critical features remain functional offline.</p>
            </div>
            <div className="feature-card glass-card">

              <h3>Multi-Platform</h3>
              <p>Available on web and mobile (iOS & Android). Responsive design that works seamlessly across all devices.</p>
            </div>
            <div className="feature-card glass-card">

              <h3>Fast & Reliable</h3>
              <p>Built with modern technologies for optimal performance. Real-time updates and instant notifications.</p>
            </div>
            <div className="feature-card glass-card">

              <h3>Analytics & Insights</h3>
              <p>Comprehensive dashboards and reports to track performance, orders, and business metrics.</p>
            </div>
            <div className="feature-card glass-card">

              <h3>Easy Management</h3>
              <p>Intuitive admin panels for managing tags, franchises, menus, orders, and transactions with ease.</p>
            </div>
            <div className="feature-card glass-card">

              <h3>Customer Support</h3>
              <p>Dedicated support system with feedback collection and customer service integration.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2 className="animate-slideUp">Technology Stack</h2>
            <p className="animate-slideUp stagger-1">
              Built with modern, scalable technologies
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card glass-card">
              <h3>Backend</h3>
              <p>
                <strong>Node.js & Express.js</strong><br />
                RESTful API architecture with PostgreSQL database. JWT-based authentication and secure data handling.
              </p>
            </div>
            <div className="feature-card glass-card">
              <h3>Frontend</h3>
              <p>
                <strong>React 18 & Vite</strong><br />
                Modern React with React Router for navigation. Responsive design with mobile-first approach.
              </p>
            </div>
            <div className="feature-card glass-card">
              <h3>Mobile</h3>
              <p>
                <strong>React Native & Expo</strong><br />
                Cross-platform mobile app for iOS and Android. Native navigation and seamless user experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2 className="animate-slideUp">Our Mission</h2>
            <p className="animate-slideUp stagger-1" style={{ maxWidth: '800px', margin: '0 auto' }}>
              To create secure, efficient, and user-friendly digital solutions that bridge communication gaps
              and streamline business operations across multiple industries.
            </p>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2 className="animate-slideUp">Our Vision</h2>
            <p className="animate-slideUp stagger-1" style={{ maxWidth: '800px', margin: '0 auto' }}>
              To become the leading platform for digital transformation across vehicle contact, restaurant management,
              and financial services. We envision a future where technology seamlessly connects people and businesses,
              making everyday interactions simpler, safer, and more efficient.
            </p>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header text-center mb-8">
            <h2 className="animate-slideUp">Our Values</h2>
            <p className="animate-slideUp stagger-1" style={{ maxWidth: '800px', margin: '0 auto' }}>
              We are committed to privacy, innovation, reliability, and customer-first approach. 
              Integrity and transparency guide everything we do.
            </p>
          </div>
          <div className="features-grid">
            <div className="feature-card glass-card"><h3>Integrity</h3><p>Honest and transparent in all our operations.</p></div>
            <div className="feature-card glass-card"><h3>Innovation</h3><p>Continuously improving our technology and services.</p></div>
            <div className="feature-card glass-card"><h3>Customer First</h3><p>Your needs and privacy are our top priority.</p></div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About





